export default __webpack_public_path__ + "static/3-ba1c311abf70f9f73828becb748fbcce.png";